<template>
  <BButton class="Button2" type="button" :block="block" variant="light">
    <slot></slot>
  </BButton>
</template>

<script>
  import { BButton } from 'bootstrap-vue'
  export default {
    name: 'Button2',
    components: {
      BButton
    },
    props: {
      block: {
        type: Boolean,
        default: false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .Button2 {
    font-weight: 500;
    line-height: 1.25;

    &.btn-brand {
      background-color: var(--colors-brand);
      border-color: var(--colors-brand);
      color: var(--accent-color-contraste);
      font-weight: 700;
    }
    &.btn-brand:hover {
      background-color: var(--colors-brand);
      border-color: var(--colors-brand);
    }
    &.btn-brand:focus {
      background-color: var(--colors-brand);
      border-color: var(--colors-brand);
    }
    &:disabled {
      cursor: not-allowed;
      opacity: .33;
    }
    &[class*="btn-outline-"]:not(:hover):not(:focus) {
      background-color: var(--colors-white);
    }    
  }
</style>
